import { assertNever } from '@deltasierra/shared';
import HelpIcon from '@material-ui/icons/Help';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import * as React from 'react';
import styled from 'styled-components';

const StyledHelpIcon = styled(HelpIcon)`
    color: ${props => props.theme.palette.info.light};
`;

const StyledHelpOutlineIcon = styled(HelpOutlineIcon)`
    color: ${props => props.theme.palette.info.light};
`;

export type HelpPopperIconStyle = 'filled' | 'none' | 'outline';

export type HelpPopperIconSize = 'default' | 'inherit' | 'large' | 'medium' | 'small';

export function getHelpPopperIcon(
    icon: HelpPopperIconStyle = 'outline',
    iconSize: HelpPopperIconSize = 'medium',
    inverted = false,
): JSX.Element | false {
    if (icon === 'none') {
        return false;
    }

    let realIcon = icon;

    if (inverted) {
        if (icon === 'filled') {
            realIcon = 'outline';

        } else if (icon === 'outline') {
            realIcon = 'filled';
        } else {
            assertNever(icon);
        }
    }

    if (realIcon === 'filled') {
        return <StyledHelpIcon fontSize={iconSize} />;

    } else if (realIcon === 'outline') {
        return <StyledHelpOutlineIcon fontSize={iconSize} />;
    } else {
        return assertNever(realIcon);
    }
}
